/// <amd-module name="Wit/DeliveryPlans/Board/BoardConstants" />

import { BoardMarker } from "Wit/DeliveryPlans/Board/BoardContracts";
import * as Resources from "Wit/DeliveryPlans/Resources";

export namespace BoardConstants {
    /**
     * Marker that will sit on the current date
     */
    export const todayMarker: BoardMarker = {
        className: "today-marker",
        color: "",
        date: new Date(),
        label: Resources.TodayString
    };

    /**
     * The number of characters that extra pill width is roughly equivalent to
     */
    export const pillPadding = 4;

    /**
     * Guesstimate of how many characters fit in a cell with a default width of 5px
     */
    export const characterToCellRatio = 1;

    /**
     * Color to use if we can't parse the marker color
     */
    export const defaultColor = "blue";

    /**
     * Width in pixels of a single day before applying the current scale
     */
    export const dayPixelWidth = 4;

    /**
     * Width of a spacer column in pixels.
     */
    export const spacerPixelWidth = dayPixelWidth / 2;

    /**
     * Width of the team header section
     * NOTE: this value needs to kept in sync with the team-header-width css value in Board.scss
     */
    export const teamHeaderWidth = 160;

    /**
     * Width of the team header section in pixels
     * NOTE: this value needs to kept in sync with the team-header-width css value in Board.scss
     */
    export const teamHeaderPixelWidth = `${teamHeaderWidth}px`;

    /**
     * The maximum number of rows of fields to display on a card.
     */
    export const maxFieldRows = 3;

    export const twoMonthsInDays = 60;

    export const oneMonthInDays = 30;

    export const defaultTimelineRenderedDays = 300;

    /**
     * The maximum number of days to render at once.
     * Webkit and Blink support a maximum of 1000 columns in a css grid.
     * Note that number of columns has an impact on performance, so we stay on the lower end of days rendered when possible.
     */
    export const maxTimelineRenderedDays = 750;

    /**
     * The maximum number of days that can be scrolled when clicking the scrolling buttons
     */
    export const maxDaysToScroll = 100;

    /**
     * Minimum scale for the board (max zoom out)
     */
    export const minScale = 0.75;

    /**
     * Maximum scale for the board (max zoom in)
     */
    export const maxScale = 12;

    /**
     * Scales to cycle through when zooming
     */
    export const scales = [minScale, 1, 2, 3, 4, 6, 8, maxScale];

    /**
     * Scale to start at.
     */
    export const defaultScale = 6;

    /**
     * At or below this scale, render cards in compact mode
     */
    export const compactScale = 3;

    /**
     * At or above this scale, always render all fields on cards
     */
    export const fullScale = maxScale;

    /**
     * Prefix for any persisted plan settings
     */
    const planPrefix = "Plans/";

    /**
     * Key used to preserve zoom state between refreshes
     */
    export const zoomKey: string = `${planPrefix}Zoom`;

    /**
     * Key used to preserve team expanded state between refreshes
     */
    export const teamKey: string = `${planPrefix}Expanded`;

    /**
     * Key used to preserve card fields collapsed state
     */
    export const cardFieldsCollapsedKey: string = `${planPrefix}CardFieldsCollapsed`;

    /**
     * Key used to designate overall expanded/collapsed button
     */
    export const allTeamsKey: string = "all-teams";
}
